// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#buttons[data-v-586db622]{width:500px;display:flex;justify-content:space-between;margin:auto}.narrower[data-v-586db622]{width:600px;margin:auto}.required[data-v-586db622]{background-color:#ffdab9;border:2px solid salmon;border-radius:8px;font-style:italic;margin-bottom:2em}.form-horizontal .row .col-sm-10 p[data-v-586db622]{text-align:left}", ""]);
// Exports
module.exports = exports;
